import { call, put, takeLatest } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callClientSecureApi } from './api/callApi'
import { FetchDriver, SkipStep } from 'src/constants/actionTypes'
import { Endpoints } from 'src/constants/endpoints'
import { captureSentryError } from 'src/utils/sentry'

interface SkipStepRequest {
  stepId: string
}

function* onSkipStep(action: AsyncAction<SkipStepRequest>) {
  const { stepId } = action.payload

  try {
    yield call(callClientSecureApi, Endpoints.SkipStep, {
      method: 'POST',
      body: { stepId },
      apiService: ApiService.Paraworks,
    })

    yield put(SkipStep.success())

    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.skipStep.onSkipStep] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to skip step'

    yield put(SkipStep.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* skipStepSaga() {
  yield takeLatest(SkipStep.type.REQUEST, onSkipStep)
}
